import { QueryKeys } from "@/constants/Query";
import { Admin } from "@/features/Admin/Admin";
import { canAccessAdminPanel } from "@/features/Admin/access";
import { adminSearchSchema } from "@/features/Admin/schemas";
import { queryClient } from "@/lib/queryClient";
import { fetchCurrentUser } from "@/network/useUser";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute("/admin")({
  // Route-level authorization: only allowlisted roles may mount the panel.
  // The in-component gate is kept as defense-in-depth. Deny (redirect home)
  // on any failure to resolve the user.
  beforeLoad: async () => {
    try {
      const user = await queryClient.ensureQueryData({
        queryKey: QueryKeys.User.ME,
        queryFn: fetchCurrentUser,
      });
      if (canAccessAdminPanel(user?.professional?.role)) return;
    } catch {
      throw redirect({ to: "/live-queue" });
    }
    // Authenticated but not allowlisted.
    throw redirect({ to: "/live-queue" });
  },
  component: Admin,
  validateSearch: zodValidator(adminSearchSchema),
});
